import { useQuery } from "react-query";
import axios from 'axios'

export const PostDetailQuery = (id) =>
  useQuery(
    `PostDetails-${id}`,
    () => axios.get(`https://api.impactrun.com/web/v1/webposts/${id}`)
  );
